import { render } from "./ChartReadme.vue?vue&type=template&id=47799632&scoped=true"
import script from "./ChartReadme.vue?vue&type=script&lang=js"
export * from "./ChartReadme.vue?vue&type=script&lang=js"

import "./ChartReadme.vue?vue&type=style&index=0&id=47799632&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47799632"]])

export default __exports__